import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Agreement,
  AgreementsService,
  AgreementStatus,
  ConsolidatedAgreementsRestService
} from '@tdwb/lazy/platform/preferences';
import {
  ModalCloseReason,
  ModalService, SecurityService, ToastMessageService
} from '@tdwb/core';
import { WebbrokerAgreementsService } from './webbroker-agreements.service';

@Component({
  selector: 'td-wb-unsigned-agreements',
  templateUrl: './unsigned-agreements.component.html',
  styleUrls: ['./unsigned-agreements.component.scss'],
  providers: [AgreementsService, WebbrokerAgreementsService, ConsolidatedAgreementsRestService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UnsignedAgreementsComponent {
  unsignedAgreements: Array<Agreement> = [];
  loading: boolean = true;
  isBlocked: boolean = false;

  constructor(private agreementsService: AgreementsService,
              private webbrokerAgreementsService: WebbrokerAgreementsService,
              private modalService: ModalService,
              private securityService: SecurityService,
              private toastMessageService: ToastMessageService,
              private changeDetectorRef: ChangeDetectorRef) {
    this.agreementsService.fetchAgreements()
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: (data: Array<Agreement>): void => {
          this.unsignedAgreements = this.getUnsignedAgreements(data);
          this.loading = false;
          this.changeDetectorRef.markForCheck();
        },
        error: (): void => {
          // Business does not want to block users from using the site when there's an error
          const topModal = this.modalService.getTopModal();
          topModal?.close(ModalCloseReason.HEADER_BUTTON);
          this.loading = false;
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  submitAgreements(): void {
    this.isBlocked = true;
    this.webbrokerAgreementsService.saveAgreementsWithNoClientData(this.unsignedAgreements).subscribe({
      next: (): void => {
        this.securityService.addUserPermission('ALL_AGREEMENTS_SIGNED');
        this.toastMessageService.setToast('tdWb.platform.unsignedAgreements.TOAST_MESSAGE')
        const topModal = this.modalService.getTopModal();
        topModal?.close(ModalCloseReason.HEADER_BUTTON);
        this.isBlocked = false;
        this.changeDetectorRef.markForCheck();
      },
      error: (): void => {
        // Business does not want to block users from using the site when there's an error
        const topModal = this.modalService.getTopModal();
        topModal?.close(ModalCloseReason.HEADER_BUTTON);
        this.isBlocked = false;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  private getUnsignedAgreements(agreements: Array<Agreement>): Array<Agreement> {
    return agreements?.filter((agreement: Agreement): boolean =>  agreement.agreementStatus === AgreementStatus.UNSIGNED) ?? [];
  }
}
